<template>
    <ac-modal title="Report Generator" ref="modalRef" :size-class="'modal-md'">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <form>
                        <div class="row">
                            <div class="col-xs-12">
                                <select v-model="selectedCreatedId" class="form-control">
                                    <option value="0"  disabled>Select A Report Date</option>
                                    <option v-for="r in reports" :value="r.createdId">
                                        {{r.createdAt}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">
                                Cancel
                            </ac-button>
                            <ac-button v-if="selectedCreatedId" class="btn btn-sm btn-green" :action="exportReport">
                                Export
                            </ac-button>
                        </div>
                    </div>
                </div>
            </div>  
            <br/>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import {formatter} from "../../../../global/formatter.js";
    
    export default {
        name: "EdiReportGeneratorModal",
        
        data() {
            return {
                reports: [],
                selectedCreatedId: 0,
                mediatorId: 0,
                mediatorName: null
            };
        },
        methods: {
            async showModal(data) {
                this.mediatorId = data.mediatorId;
                this.mediatorName = data.mediatorName;
                this.reports = await api.getData('Mediator', this.mediatorId, 'GetMediatorBatches');
                this.$refs.modalRef.open();        
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            exportReport() {
                var fileName = this.mediatorName + "-EdiErrorsReport-(" + this.selectedCreatedId + ").csv";
                var query = "?createdId=" + this.selectedCreatedId;
                common.downloadFile("Mediator/" + this.mediatorId + "/ExportAdminEdiResults/" + query, fileName);
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>